const namespace = "marApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Medical Application Request",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  parentRoute: "/med-app-req",
  defaultRoute: "Request",
  accentColor: "#000080",
  childRoutes,
  component : () => import(/* webpackChunkName: "med-app-req-parent" */ "@/apps/med-app-req/Application.vue"),
  navigation : [],
  settings: {
    navigation: [{
      text: "New Request",
      link: `/med-app-req/Request`,
      icon: "mdi-hand",
    },
    // {
    //   text: "Help",
    //   link: "help",
    //   icon: "mdi-help-circle",
    // },
    // {
    //   text: "Config",
    //   link: "config",
    //   icon: "mdi-hammer-wrench",
    // },
  ],
    environment : "DEV",
    //scope: "api://38f1b253-537f-4d01-8f87-58726a6c6621/Read.All",
    //clientId: "38f1b253-537f-4d01-8f87-58726a6c6621",  
    scope: "api://0a00d2f5-2545-4cc9-9691-681cff842c47/Read.All",
    clientId: "0a00d2f5-2545-4cc9-9691-681cff842c47",
    //scope: "api://c7c08750-61ed-4fe0-ac48-54bbad5b46d0/Read.All",
    //clientId: "c7c08750-61ed-4fe0-ac48-54bbad5b46d0",
    
    //apiUrl: "https://as-dataqualityplatformapi-dev.azurewebsites.net/api",
    apiUrl: "https://localhost:44358/api",
    odataUrl: "https://localhost:44358/odata",
    // apiUrl: "https://as-medappreq-api-dev.azurewebsites.net/api",
    // odataUrl: "https://as-medappreq-api-dev.azurewebsites.net/odata",
    //apiUrl: "https://as-medappreq-api-dev.azurewebsites.net/api",
    // scope: "api://dd02aafe-7da8-4767-bb50-d40ca73969dc/Read.All", //STG - test  
    // clientId: "dd02aafe-7da8-4767-bb50-d40ca73969dc", //STG - test
    // apiUrl: "https://dqpapi-stg.lyondellbasell.com/api", //STG - test
    authorizeUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    redirect_uri: window.location.origin,
    logoutUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080/",
    tokenUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    reaptcha_public_sitekey: "6LcEluYfAAAAALCX1_tLaKH_O5Pgxf_WD4pTs4I4",

    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 }, 
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    isAzureDeployed: true,
    //env_color:'"primary"', //PROD
    powerBiUrl:
      "https://app.powerbi.com/groups/me/apps/33ef19d6-561b-42ed-9c87-a7d0096a24e6/reports/60a5d668-c227-4c70-8d47-f1d6f8b93e6c/ReportSection",
    frmlink:
      "https://lyondellbasell.sharepoint.com/sites/Elements/Departments/Finance/Finance-Departments/financestrategytransformation/SharedServices/Pages/Master-Data-Management(1).aspx"
  },

  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    pageTitle: {
      default: "Medical Application Request",
      storageMode: localStorage,
    },
    userDetails: {
      default: {},
      storageMode: sessionStorage,
    },
  },

}

export default AppConfig.merge(appConfig);


